import axios from "axios"

export default class PaymentService {
  async pay(paymentMethod, amount, billingDetails = {}) {
    const response = await axios.post("/pay", { paymentMethod, amount, billingDetails })
    return response
  }
}
